export default "__VITE_ASSET__olgGDzVP__"